export const API_URL = "https://api.$HOSTNAME:$PORT/api";
export const WEBHOOK_URL = "https://webhook.$HOSTNAME:$PORT";
export const API_VERSION = "1";